import api from "@/lib/api";

// Status → tailwind badge classes (dark theme).
export const templateStatusColor = {
  "Draft": "bg-slate-500/15 text-slate-300 border-slate-500/30",
  "Internal Review": "bg-sky-500/15 text-sky-300 border-sky-500/30",
  "Legal Review Required": "bg-amber-500/15 text-amber-300 border-amber-500/30",
  "Approved": "bg-emerald-500/15 text-emerald-300 border-emerald-500/30",
  "Superseded": "bg-slate-600/15 text-slate-400 border-slate-600/30",
  "Archived": "bg-slate-700/15 text-slate-500 border-slate-700/30",
};

export const reviewStatusColor = {
  "Not Sent": "bg-slate-500/15 text-slate-300 border-slate-500/30",
  "Preparing Review": "bg-slate-500/15 text-slate-300 border-slate-500/30",
  "Sent for Review": "bg-sky-500/15 text-sky-300 border-sky-500/30",
  "Under Review": "bg-indigo-500/15 text-indigo-300 border-indigo-500/30",
  "Changes Requested": "bg-amber-500/15 text-amber-300 border-amber-500/30",
  "Reviewed — No Changes": "bg-emerald-500/15 text-emerald-300 border-emerald-500/30",
  "Reviewed — Changes Recommended": "bg-amber-500/15 text-amber-300 border-amber-500/30",
  "Approved": "bg-emerald-500/15 text-emerald-300 border-emerald-500/30",
  "Rejected": "bg-rose-500/15 text-rose-300 border-rose-500/30",
  "Review Closed": "bg-slate-600/15 text-slate-400 border-slate-600/30",
};

export const severityColor = {
  critical: "border-rose-500/30 bg-rose-500/10 text-rose-300",
  warning: "border-amber-500/30 bg-amber-500/10 text-amber-300",
  info: "border-sky-500/30 bg-sky-500/10 text-sky-300",
};

export function Badge({ value, map, testId }) {
  const cls = (map && map[value]) || "bg-slate-500/15 text-slate-300 border-slate-500/30";
  return (
    <span data-testid={testId} className={`inline-flex items-center rounded-md border px-2 py-0.5 text-[11px] font-medium ${cls}`}>
      {value}
    </span>
  );
}

// Open a template-version PDF (fetched as an authenticated blob) in a new tab.
export async function openVersionPdf(templateId, version, mode = "clean") {
  const res = await api.get(`/legal/templates/${templateId}/versions/${version}/pdf`, {
    params: { mode }, responseType: "blob",
  });
  const url = URL.createObjectURL(new Blob([res.data], { type: "application/pdf" }));
  window.open(url, "_blank");
  setTimeout(() => URL.revokeObjectURL(url), 60000);
}

// Download a template-version as .docx (authenticated blob).
export async function downloadVersionDocx(templateId, version) {
  const res = await api.get(`/legal/templates/${templateId}/versions/${version}/docx`, { responseType: "blob" });
  const url = URL.createObjectURL(new Blob([res.data]));
  const a = document.createElement("a");
  a.href = url; a.download = `${version}.docx`; a.click();
  setTimeout(() => URL.revokeObjectURL(url), 60000);
}
